import { Box } from "@mui/material";
import { useState } from "react";
import PageContainer from "src/pages/components/PageContainer"
import { getFirstDayOfMonth, getLastDayOfMonth } from "src/utils/date";
import MyActionsTable from "./components/MyActionsTable";
import { PsychologistAction, getPsychologistActions } from "src/apis/action";
import { isUserPsychologist } from "src/utils/auth";
import StartAndEndDateFilters from "src/pages/components/StartAndEndDateFilters";
import FilterButtons from "src/pages/components/SearchAndResetButtons";
import SkeletonLoad from "src/pages/components/SkeletonLoad";

const MyActions: React.FC = (): JSX.Element => {
  const [filterStartDate, setFilterStartDate] = useState(getFirstDayOfMonth());
  const [filterEndDate, setFilterEndDate] = useState(getLastDayOfMonth());
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [actions, setActions] = useState<PsychologistAction[]>([]);

  const fetchData = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const res = await getPsychologistActions(filterStartDate, filterEndDate);

      setActions(res);
      setError('');
    } catch(err: any) {
      setError(err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageContainer title="Minhas ações realizadas" error={error} guard={isUserPsychologist}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        }}
      >
        <StartAndEndDateFilters
          startDate={filterStartDate}
          setStartDate={setFilterStartDate}
          endDate={filterEndDate}
          setEndDate={setFilterEndDate}
        />
        <FilterButtons
          isLoading={isLoading}
          registerUrl="/acoes/cadastro"
          search={() => {
            fetchData()
          }}
          resetState={() => {
            setFilterStartDate(getFirstDayOfMonth());
            setFilterEndDate(getLastDayOfMonth());
            setActions([]);
          }}
        />
      </Box>

      <Box>
        {isLoading && (
          <SkeletonLoad variant="table" rows={6} columns={8} />
        )}

        {!error && (
          <MyActionsTable actions={actions} />
        )}
      </Box>
    </PageContainer>
  )
}

export default MyActions;
